export default __webpack_public_path__ + "static/media/flowers-1x.e47451a1.png";